<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getProcedures");
    this.$store.dispatch("lookups/getPaymentAccounts");
    this.$store.dispatch("lookups/getDoctors");
  },
  computed: {
    paymentTypes() {
      return this.$store.state.lookups.paymentAccounts;
    },
    itemPriceList() {
      return this.$store.state.lookups.itemPriceList || [];
    },
    procedures() {
      return [{
        value: "خدمات قسم التجميل الجراحي",
        label: "خدمات قسم التجميل الجراحي"
      },
      {
        value: "خدمات قسم التجميل اللاجراحي",
        label: "خدمات قسم التجميل اللاجراحي"
      },
      {
        value: "خدمات قسم التغذية",
        label: "خدمات قسم التغذية"
      },
      {
        value: "خدمات قسم العناية بالبشرة",
        label: "خدمات قسم العناية بالبشرة"
      },
      {
        value: "خدمات قسم الليزر",
        label: "خدمات قسم الليزر"
      }]
      // return  this.$store.state.lookups.procedures.filter(x => x.value != "الاصول الثابتة" &&  x.value !=  "خدمات تحاليل")
    },
    DiscountType(){
      return [
        {value :1,label:"قيمة"},
        {value :2,label:"نسبة"},
      ]
    },
totalAmount(){
    if(this.vm.services.length == 0) return 0;
    else{
   
     var sum = 0;
       this.vm.services.forEach(x => sum+=x.price);
       if(this.vm.discountType == 1 && this.vm.discount != null) sum-= this.vm.discount;
       else if(this.vm.discountType == 2 && this.vm.discount != null) sum-= sum * (this.vm.discount/100);
      return sum;
    }
},
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },
  },
  data() {
    return {
      appointments: [],
      patient: {
        fullName: null,
        fileNo: null,
      },

      allowedDays: [],
      patients: [],
      selectedPatient: {
        fullName: null,
        fileNo: null
      },
      showResult: false,
      showBtn: false,
      dialog: false,
      searchTrem: null,
      vm: {
        discountType: null,
        discount: null,
        patientId: null,
        invoiceDate: null,
        appointmentId: null,
        doctorId: null,
        // invoiceTypeId: null,
        services: [],
        // analysis: []
      },
      service: {
        serviceName: null,
        price: null,
        discount: null,
      },
      // service: {
      //   serviceId: null,
      //   serviceDetailsId: null,
      //   price: null,
      // },
      servicePrice: null,
      indexItem: null,
      editFlag: false,
      headersService: [
        { text: 'اسم الخدمة', value: 'serviceName' },
        { text: 'السعر ', value: 'price' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      procedureId:null,
    };
  },
  methods: {
    getServices(){
      this.$store.dispatch("lookups/GetItemByProcedure", this.procedureId);
    },
    getPrice() {
      this.service.price = null;
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.service.price = service.price;
    },
    getAppointments() {
      this.appointments = [];
      this.vm.appointmentDate = null;
      this.$store
        .dispatch("invoices/getAppointments", {
          patientId: this.vm.patientId,
          doctorId: this.vm.doctorId,
        })
        .then((res) => {
          this.appointments = res;
        })
        .catch(() => { });
    },

    // getAnalysis() {
    //   this.$store.dispatch("lookups/getAnalysis", this.analysas.analysisGroupId);

    // },
    // changeService() {
    //   this.servicePrice = null;
    //   this.service.price = null;

    //   let service = this.services.find((x) => x.value == this.service.serviceId);
    //   this.servicePrice = service.price;
    //   if (service.price != null) {
    //     this.service.price = service.price;
    //   }
    // },
    // changeSubService() {
    //   this.service.price = null;
    //   let service = this.subServices.find((x) => x.value == this.service.serviceDetailsId);
    //   if (service.price != null) {
    //     this.service.price = service.price;
    //   }
    // },
    // changeAnalysis() {
    //   this.analysas.price = null;
    //   let analysas = this.analysis.find((x) => x.value == this.analysas.analysisId);
    //   this.analysas.price = analysas.price;
    // },
    confirm() {
      this.$refs.form.validate().then(valid => {
        if (valid) {

          // if ((this.vm.invoiceTypeId == 13001 && this.vm.services.length == 0) ||
          //   (this.vm.invoiceTypeId == 13002 && this.vm.analysis.length == 0)) {
          //   showAlert(`يجب ادخال عنصر واحد على الاقل`);
          //   return false;
          // }
          if (this.vm.services.length == 0) {
            showAlert(`يجب ادخال عنصر واحد على الاقل`);
            return false;
          }
          this.$store
            .dispatch("invoices/add", this.vm)
            .then(() => {
              this.back();
            })
            .catch(() => { });
        } else {
          showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

        }
      });

    },
    AddItem() {
      // if (this.service.serviceId == null) {
      //   showAlert(`يجب اختيار الخدمة `);
      //   return false;
      // }
      // if (this.service.price == null) {
      //   showAlert(`يجب ادخال السعر `);
      //   return false;
      // }
      // this.vm.services.push({
      //   serviceId: this.service.serviceId,
      //   serviceName: this.services.find((e) => e.value == this.service.serviceId).label,
      //   serviceDetails: this.service.serviceDetailsId == null ? '-' : this.subServices.find((e) => e.value == this.service.serviceDetailsId).label,
      //   serviceDetailsId: this.service.serviceDetailsId,
      //   price: this.service.price,
      // });
      // this.service.serviceId = null;
      // this.service.serviceDetailsId = null;
      // this.service.price = null;
      if (this.service.serviceName == null) {
        showAlert(`يجب اختيار الخدمة `);
        return false;
      }
      if (this.service.price == null) {
        showAlert(`يجب ادخال السعر `);
        return false;
      }
      var Index = this.vm.services.findIndex(x => x.serviceName == this.service.serviceName);
      if (Index != -1) {
        showAlert(`لا يمكن اضافة نفس الخدمة اكثر من مرة   `);
        return false;
      }
      let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
      this.vm.services.push({
        serviceName: this.service.serviceName,
        serviceCode: service.itemCode,
        price: this.service.price,
        discount: this.service.discount,
      });
      this.service.serviceName = null;
      this.service.price = null;
      this.service.discount = null;
      //this.$refs.info.reset();
    },

    removeItem(index) {
      this.vm.services.splice(index, 1);
    },
    back() {
      this.$emit("back");
    },

    //----------------------------------------------------//
    // AddAnalysisItem() {
    //   if (this.analysas.analysisGroupId == null) {
    //     showAlert(`يجب اختيار التصنيف `);
    //     return false;
    //   } else if (this.analysas.analysisId == null) {
    //     showAlert(`يجب اختيار التحليل   `);
    //     return false;
    //   }
    //   this.vm.analysis.push({
    //     analysisGroupId: this.analysas.analysisGroupId,
    //     analysisId: this.analysas.analysisId,
    //     analysisName: this.analysis.find((e) => e.value == this.analysas.analysisId).label,
    //     analysisGroupName: this.analysisGroups.find((e) => e.value == this.analysas.analysisGroupId).label,
    //     price: this.analysas.price,
    //   });

    //   this.analysas.analysisGroupId = null;
    //   this.analysas.analysisId = null;
    //   this.analysas.price = null;
    //   //this.$refs.info.reset();
    // },
    // removeAnalysisItem(index) {
    //   this.vm.analysis.splice(index, 1);
    // },

    //----------------------------------------------------//

    SearchPatient() {
      this.showResult = false;
      this.patients = [];
      this.selectedPatient.fullName = null;
      this.selectedPatient.fileNo = null;
      this.vm = {
        patientId: null,
        invoiceDate: null,
        appointmentId: null,
        // invoiceTypeId: null,
        services: [],
        // analysis: []
      };
      if (this.searchTrem == null || this.searchTrem == "" || this.searchTrem.length < 9) {
        showAlert(`الرجاء ادخال رقم الهاتف`);
        return false;
      }

      this.$store
        .dispatch("appointments/search", { searchTrem: this.searchTrem })
        .then((res) => {

          if (res.statusCode == 1) {
            this.showResult = true
            this.patients = res.patients;
            this.dialog = true;
          }
        })
        .catch(() => { });
    },
    confirmDialog() {
      let that = this;
      this.patients.forEach((el) => {
        if (that.vm.patientId == el.id) {

          that.selectedPatient = el
          return el
        }
      });

      this.dialog = false
    },

  },
};
</script>